import qs from "qs";
import { addError } from './error';
import api from '../../helpers/ApiClient';
import _ from "lodash"

export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';
export const CLEAR_ORDERS = 'CLEAR_ORDERS';

function fetchOrdersRequest() {
  return {
    type: FETCH_ORDERS_REQUEST
  };
}

function fetchOrdersSuccess(json) { 

  _.each(json, function(order){
    let shippingDetail = order.shippingDetail
    order.name = shippingDetail.name
    order.state = shippingDetail.state
  })

  return {
    type: FETCH_ORDERS_SUCCESS,
    payload: {
      items: json,
      receivedAt: Date.now()
    }
  };
}

function fetchOrdersFailure() {
  return {
    type: FETCH_ORDERS_FAILURE
  };
}

function shouldFetchOrders(state) {
  const results = state.orders;
  if (results && results.loading) {
    return false;
  } 
  else {
    return true;
  }
}

function fetchOrdersFromApi(jobStatus, shippingMethod, startDate, endDate, dispatchDate) {

  let start_date = startDate.format('D-M-YY');
  let end_date = endDate.format('D-M-YY');

  let body = {
    start_date, end_date, jobStatus, shippingMethod
  }

  if(dispatchDate){
    let dispatch_date = dispatchDate.format('D-M-YY')
    body.dispatch_date = dispatch_date
  }

  const queryString = qs.stringify(body, { skipNulls: true });

  // console.log(queryString)

  return dispatch => {
    dispatch(fetchOrdersRequest());
    return api(`api/orders?${queryString}`)
      .then(json => {
        dispatch(fetchOrdersSuccess(json));
      })
      .catch(err => {
        dispatch(fetchOrdersFailure());
        dispatch(addError(err));
      });
  };
}

export function fetchOrders(jobStatus, shippingMethod, startDate, endDate, dispatchDate) {
  return (dispatch, getState) => {
    if (shouldFetchOrders(getState())) {
      return dispatch(fetchOrdersFromApi(jobStatus, shippingMethod, startDate, endDate, dispatchDate));
    }
  };
}

export function clearOrders() {
  return {
    type: CLEAR_ORDERS,
  };
}